import React, { useRef, useState } from 'react'
import { IoMdArrowDropleft, IoMdArrowDropright } from "react-icons/io";
import { useSelector } from 'react-redux';
import { all_userneed_psychometrics } from '../../../redux/Slices/dashboardSlice';
import { IoCloseSharp } from "react-icons/io5";
import PriorityGraphUserNeeds from './PriorityGraphUserNeeds';



function StatsPsychometrics() {
    const scrollContainerRef = useRef(null);

    const userneed_dashboard = useSelector(all_userneed_psychometrics)
    const loadingStatus = useSelector(state => state.dashboardData.loading)
    const [displayFullPsychometric, setDisplayFullPsychometric] = useState(null)




    const handlePsychometrics = (data) => {
      setDisplayFullPsychometric(data)
    }

    const scroll = (direction) => {
        const container = scrollContainerRef.current;
        if (container) {
          const scrollAmount = container.clientWidth / 2; // Scroll by half the container's width
          // If direction is right, scroll by half of the div width
          // else If direction is left, scroll by negative half of the div width
          container.scrollBy({
            left: direction === 'right' ? scrollAmount : -scrollAmount,
            behavior: 'smooth'
          });
        }
      };


  return (
    <div>
    <div className='flex relative h-[350px] my-4'>


    {/* ARROW LEFT */}
    <div className='h-full flex items-center'>
    <IoMdArrowDropleft
     onClick={() => scroll('left')}
     className='cursor-pointer
                 text-3xl md:text-6xl text-white' />
    </div>


{/* GRAPHS */}
       <div
       ref={scrollContainerRef}
       style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
       className='flex w-[97%] overflow-y-hidden
       overflow-x-scroll space-x-6'>

      {loadingStatus ?
      <div className='bg-white  text-black w-full h-full flex flex-col justify-center items-center'>
            <div className='h-14 border-black w-14 rounded-full border-t-4 animate-spin ' />
            <p className='my-3'>Loading Charts</p>
     </div>
       :
        <>
        {userneed_dashboard?.chart_data ?
         <div
         className='cursor-pointer' 
         onTouchStart={() => handlePsychometrics(userneed_dashboard, null)} 
         onClick={() => handlePsychometrics(userneed_dashboard, null)}>
         <PriorityGraphUserNeeds processedData={userneed_dashboard} />
        </div>
        :
      <div className='bg-white  text-black w-full h-full flex flex-col justify-center items-center'>
            <p className='my-3 font-semibold'>No Userneed Priority Graph </p>
     </div>
        }
        </>

       }




       </div>

{/* ARROW RIGHT */}
       <div className='h-full flex items-center'>
     <IoMdArrowDropright
     onClick={() => scroll('right')}
     className='cursor-pointer
                 text-3xl md:text-6xl text-white' />
        </div>

     </div>


    {/* Display Full Chart */}
     {displayFullPsychometric &&


         <div 
         onClick={() => {
                  setDisplayFullPsychometric(null)
                }}
         className='h-full w-full flex justify-center items-center bg-nightModeDark_600
                text-white p-6 fixed top-0 left-0 z-[1000] bg-opacity-75'>

                <button 
                onClick={() => {
                  setDisplayFullPsychometric(null)
                }}
                className='absolute top-1 right-3 text-white'>
                  <IoCloseSharp className='cursor-pointer text-4xl' />
                </button>

                <div 
                onClick={(e) =>  e.stopPropagation()}
                className='w-[90vw] h-[95vh] overflow-y-scroll'>
                   <PriorityGraphUserNeeds processedData={userneed_dashboard} />
                </div>
                  
                </div>
     
      }



     </div>
  )
}

export default StatsPsychometrics
